export enum AuthURL {
  AUTH_REGISTER_DEVICE = "/sso/oauth/app/",
  AUTH_REQUEST_ACCESS_TOKEN = "/sso/oauth/token/",
  AUTH_REQUEST_AUTHORIZATION_CODE = "/sso/oauth/authorize/",
  AUTH_REVOKE_TOKEN = "/sso/oauth/revoke_token/",
  AUTH_VERIFY_ACCESS_TOKEN = "/sso/verify/",
}

export enum SpringboardURL {
  //region Users

  USER_ID = "/v1/users/{id}/",
  USER_ID_IMAGE = "/v1/users/{id}/image/",
  USER_ME = "/v1/users/me/",
  USER_ME_IMAGE = "/v1/users/me/image/",
  USER_ME_PASSWORD = "/v1/users/me/password/",
  USER_ROLES = "/v1/users/roles/",

  //endregion

  //region Workspaces

  WORKSPACES_LIST = "/v1/workspaces/",
  WORKSPACES_ID = "/v1/workspaces/{id}/",
  WORKSPACES_ID_USERS = "/v1/workspaces/{id}/users/",

  //endregion

  //region Work Domains

  WORK_DOMAINS = "/v1/workdomains/",
  WORK_DOMAINS_ID = "/v1/workdomains/{id}/",

  //endregion
}

export enum CSIurl {
  //region Attachments

  ATTACHMENTS_LIST = "/v1/attachments/",
  ATTACHMENTS_ID = "/v1/attachments/{id}/",
  ATTACHMENTS_ID_CONTENT = "/v1/attachments/{id}/content/",
  ATTACHMENTS_BATCH = "/v1/attachments/batch/",

  //endregion

  //region Attributes

  ATTRIBUTES_CHAR_LIST = "/v1/attributes/char/",
  ATTRIBUTES_NUMERIC_LIST = "/v1/attributes/numeric/",
  ATTRIBUTES_SELECT_LIST = "/v1/attributes/select/",
  ATTRIBUTES_TEMPORAL_LIST = "/v1/attributes/temporal/",
  ATTRIBUTES_CHAR = "/v1/attributes/char/{id}/",
  ATTRIBUTES_NUMERIC = "/v1/attributes/numeric/{id}/",
  ATTRIBUTES_SELECT = "/v1/attributes/select/{id}/",
  ATTRIBUTES_TEMPORAL = "/v1/attributes/temporal/{id}/",
  ATTRIBUTES_CHAR_VALUES_BATCH = "/v1/attributes/char/values/batch/",
  ATTRIBUTES_NUMERIC_VALUES_BATCH = "/v1/attributes/numeric/values/batch/",
  ATTRIBUTES_SELECT_VALUES_BATCH = "/v1/attributes/select/values/batch/",
  ATTRIBUTES_TEMPORAL_VALUES_BATCH = "/v1/attributes/temporal/values/batch/",
  ATTRIBUTES_SELECT_OPTIONS_LIST = "/v1/attributes/select/options/",
  ATTRIBUTES_SELECT_OPTIONS = "/v1/attributes/select/options/{id}/",
  ATTRIBUTES_SELECT_OPTIONS_ATTR_ID = "/v1/attributes/select/{attr_id}/options/",

  //endregion

  //region Identifiers

  IDENTIFIERS_LIST = "/v1/identifiers/",
  IDENTIFIERS_BATCH = "/v1/identifiers/batch/",
  IDENTIFIERS_TYPE = "/v1/identifiers/{iden_type}/",
  IDENTIFIERS_TYPE_ID = "/v1/identifiers/{iden_type}/{iden_id}/",

  //endregion

  //region Issue Priorities

  ISSUE_PRIORITIES = "/v1/issuepriorities/",
  ISSUE_PRIORITIES_ID = "/v1/issuepriorities/{id}/",

  //endregion

  //region Issues

  ISSUE_ON_ITEM_ACTIONS = "/v1/issues/onitem/actions/",
  ISSUE_ON_ITEM_ACTIONS_ID = "/v1/issues/onitem/actions/{id}/",
  ISSUE_ON_ITEM_ACTIONS_BATCH = "/v1/issues/onitem/actions/batch/",

  ISSUES_ON_ITEM = "/v1/issues/onitem/",
  ISSUES_ON_ITEM_ID = "/v1/issues/onitem/{id}/",
  ISSUES_ON_ITEM_BATCH = "/v1/issues/onitem/batch/",

  ISSUES_ON_ITEM_ATTACHMENTS_LIST = "/v1/issues/onitem/{issue_id}/attachments/",
  ISSUES_ON_ITEM_ATTACHMENTS_ID = "/v1/issues/onitem/{issue_id}/attachments/{id}/",
  ISSUES_ON_ITEM_ATTACHMENTS_ID_CONTENT = "/v1/issues/onitem/{issue_id}/attachments/{id}/content/",
  ISSUES_ON_ITEM_ATTACHMENTS_BATCH = "/v1/issues/onitem/{issue_id}/attachments/batch/",

  ISSUES_ON_ITEM_COMMENTS = "/v1/issues/onitem/comments/",
  ISSUES_ON_ITEM_COMMENTS_ID = "/v1/issues/onitem/comments/{id}/",
  ISSUES_ON_ITEM_COMMENTS_BATCH = "/v1/issues/onitem/comments/batch/",

  ISSUES_ON_ITEM_COMMENTS_ATTACHMENTS = "/v1/issues/onitem/comments/{comment_id}/attachments/",
  ISSUES_ON_ITEM_COMMENTS_ATTACHMENTS_ID = "/v1/issues/onitem/comments/{comment_id}/attachments/{id}/",
  ISSUES_ON_ITEM_COMMENTS_ATTACHMENTS_ID_CONTENT = "/v1/issues/onitem/comments/{comment_id}/attachments/{id}/content/",
  ISSUES_ON_ITEM_COMMENTS_ATTACHMENTS_BATCH = "/v1/issues/onitem/comments/{comment_id}/attachments/batch/",

  //endregion

  //region Items

  ITEMS = "/v1/items/",
  ITEMS_BATCH = "/v1/items/batch/",
  ITEMS_SEARCH = "/v1/items/search/",
  ITEMS_ID = "/v1/items/{id}/",
  ITEMS_ID_ATTACHMENTS_LIST = "/v1/items/{item_id}/attachments/",
  ITEMS_ID_ATTACHMENTS_ID = "/v1/items/{item_id}/attachments/{id}/",
  ITEMS_ID_ATTACHMENTS_ID_CONTENT = "/v1/items/{item_id}/attachments/{id}/content/",
  ITEMS_ID_ATTACHMENTS_BATCH = "/v1/items/{item_id}/attachments/batch/",
  ITEMS_ATTRIBUTES_CHAR_VALUES_LIST = "/v1/items/attributes/char/values/",
  ITEMS_ATTRIBUTES_NUMERIC_VALUES_LIST = "/v1/items/attributes/numeric/values/",
  ITEMS_ATTRIBUTES_SELECT_VALUES_LIST = "/v1/items/attributes/select/values/",
  ITEMS_ATTRIBUTES_TEMPORAL_VALUES_LIST = "/v1/items/attributes/temporal/values/",
  ITEMS_ATTRIBUTES_CHAR_VALUES = "/v1/items/{item_id}/attributes/char/values/",
  ITEMS_ATTRIBUTES_NUMERIC_VALUES = "/v1/items/{item_id}/attributes/numeric/values/",
  ITEMS_ATTRIBUTES_SELECT_VALUES = "/v1/items/{item_id}/attributes/select/values/",
  ITEMS_ATTRIBUTES_TEMPORAL_VALUES = "/v1/items/{item_id}/attributes/temporal/values/",
  ITEMS_ATTRIBUTES_CHAR_VALUE = "/v1/items/{item_id}/attributes/char/{attr_id}/value/",
  ITEMS_ATTRIBUTES_NUMERIC_VALUE = "/v1/items/{item_id}/attributes/numeric/{attr_id}/value/",
  ITEMS_ATTRIBUTES_SELECT_VALUE = "/v1/items/{item_id}/attributes/select/{attr_id}/value/",
  ITEMS_ATTRIBUTES_TEMPORAL_VALUE = "/v1/items/{item_id}/attributes/temporal/{attr_id}/value/",
  ITEMS_WORK_ORDER_REGULAR = "/v1/items/{item_id}/workorders/regular/",

  //endregion

  //region Item Classes

  ITEM_CLASSES_LIST = "/v1/itemclasses/",
  ITEM_CLASSES_ID = "/v1/itemclasses/{id}/",

  //endregion

  //region Item Models

  ITEM_MODELS = "/v1/itemmodels/",
  ITEM_MODELS_ID = "/v1/itemmodels/{id}/",
  ITEM_MODELS_ID_ATTACHMENTS_LIST = "/v1/itemmodels/{model_id}/attachments/",
  ITEM_MODELS_ID_ATTACHMENTS_ID = "/v1/itemmodels/{model_id}/attachments/{id}/",
  ITEM_MODELS_ID_ATTACHMENTS_ID_CONTENT = "/v1/itemmodels/{model_id}/attachments/{id}/content/",
  ITEM_MODELS_ID_ATTACHMENTS_BATCH = "/v1/itemmodels/{model_id}/attachments/batch/",
  ITEM_MODELS_ATTRIBUTES_CHAR_VALUES_LIST = "/v1/itemmodels/attributes/char/values/",
  ITEM_MODELS_ATTRIBUTES_NUMERIC_VALUES_LIST = "/v1/itemmodels/attributes/numeric/values/",
  ITEM_MODELS_ATTRIBUTES_SELECT_VALUES_LIST = "/v1/itemmodels/attributes/select/values/",
  ITEM_MODELS_ATTRIBUTES_TEMPORAL_VALUES_LIST = "/v1/itemmodels/attributes/temporal/values/",
  ITEM_MODELS_ATTRIBUTES_CHAR_VALUES = "/v1/itemmodels/{item_model_id}/attributes/char/values/",
  ITEM_MODELS_ATTRIBUTES_NUMERIC_VALUES = "/v1/itemmodels/{item_model_id}/attributes/numeric/values/",
  ITEM_MODELS_ATTRIBUTES_SELECT_VALUES = "/v1/itemmodels/{item_model_id}/attributes/select/values/",
  ITEM_MODELS_ATTRIBUTES_TEMPORAL_VALUES = "/v1/itemmodels/{item_model_id}/attributes/temporal/values/",
  ITEM_MODELS_ATTRIBUTES_CHAR_VALUE = "/v1/itemmodels/{item_model_id}/attributes/char/{attr_id}/value/",
  ITEM_MODELS_ATTRIBUTES_NUMERIC_VALUE = "/v1/itemmodels/{item_model_id}/attributes/numeric/{attr_id}/value/",
  ITEM_MODELS_ATTRIBUTES_SELECT_VALUE = "/v1/itemmodels/{item_model_id}/attributes/select/{attr_id}/value/",
  ITEM_MODELS_ATTRIBUTES_TEMPORAL_VALUE = "/v1/itemmodels/{item_model_id}/attributes/temporal/{attr_id}/value/",

  //endregion

  //region Performed Work

  // TODO: Uncomment when we have areas
  // PERFORMED_WORK_CORRECTIVE_AREA_LIST = "/v1/performedwork/corrective/onarea/",
  // PERFORMED_WORK_CORRECTIVE_AREA_ID = "/v1/performedwork/corrective/onarea/{id}/",
  // PERFORMED_WORK_CORRECTIVE_AREA_BATCH = "/v1/performedwork/corrective/onarea/batch/",
  // PERFORMED_WORK_CORRECTIVE_AREA_ATTACHMENTS_LIST = "/v1/performedwork/corrective/onarea/{work_id}/attachments/",
  // PERFORMED_WORK_CORRECTIVE_AREA_ATTACHMENTS_ID = "/v1/performedwork/corrective/onarea/{work_id}/attachments/{id}/",
  // PERFORMED_WORK_CORRECTIVE_AREA_ATTACHMENTS_ID_CONTENT = "/v1/performedwork/corrective/onarea/{work_id}/attachments/{id}/content/",
  // PERFORMED_WORK_CORRECTIVE_AREA_ATTACHMENTS_BATCH = "/v1/performedwork/corrective/onarea/{work_id}/attachments/batch/",

  PERFORMED_WORK_CORRECTIVE_ITEM_LIST = "/v1/performedwork/corrective/onitem/",
  PERFORMED_WORK_CORRECTIVE_ITEM_ID = "/v1/performedwork/corrective/onitem/{id}/",
  PERFORMED_WORK_CORRECTIVE_ITEM_BATCH = "/v1/performedwork/corrective/onitem/batch/",
  PERFORMED_WORK_CORRECTIVE_ITEM_ATTACHMENTS_LIST = "/v1/performedwork/corrective/onitem/{work_id}/attachments/",
  PERFORMED_WORK_CORRECTIVE_ITEM_ATTACHMENTS_ID = "/v1/performedwork/corrective/onitem/{work_id}/attachments/{id}/",
  PERFORMED_WORK_CORRECTIVE_ITEM_ATTACHMENTS_ID_CONTENT = "/v1/performedwork/corrective/onitem/{work_id}/attachments/{id}/content/",
  PERFORMED_WORK_CORRECTIVE_ITEM_ATTACHMENTS_BATCH = "/v1/performedwork/corrective/onitem/{work_id}/attachments/batch/",

  PERFORMED_WORK_CORRECTIVE_ITEM_COMMENTS = "/v1/performedwork/corrective/onitem/comments/",
  PERFORMED_WORK_CORRECTIVE_ITEM_COMMENTS_ID = "/v1/performedwork/corrective/onitem/comments/{id}/",
  PERFORMED_WORK_CORRECTIVE_ITEM_COMMENTS_BATCH = "/v1/performedwork/corrective/onitem/comments/batch/",

  PERFORMED_WORK_CORRECTIVE_ITEM_COMMENTS_ATTACHMENTS = "/v1/performedwork/corrective/onitem/comments/{comment_id}/attachments/",
  PERFORMED_WORK_CORRECTIVE_ITEM_COMMENTS_ATTACHMENTS_ID = "/v1/performedwork/corrective/onitem/comments/{comment_id}/attachments/{id}/",
  PERFORMED_WORK_CORRECTIVE_ITEM_COMMENTS_ATTACHMENTS_ID_CONTENT = "/v1/performedwork/corrective/onitem/comments/{comment_id}/attachments/{id}/content/",
  PERFORMED_WORK_CORRECTIVE_ITEM_COMMENTS_ATTACHMENTS_BATCH = "/v1/performedwork/corrective/onitem/comments/{comment_id}/attachments/batch/",

  // TODO: Uncomment when we have areas
  // PERFORMED_WORK_REGULAR_AREA_LIST = "/v1/performedwork/regular/onarea/",
  // PERFORMED_WORK_REGULAR_AREA_ID = "/v1/performedwork/regular/onarea/{id}/",
  // PERFORMED_WORK_REGULAR_AREA_BATCH = "/v1/performedwork/regular/onarea/batch/",
  // PERFORMED_WORK_REGULAR_AREA_ATTACHMENTS_LIST = "/v1/performedwork/regular/onarea/{work_id}/attachments/",
  // PERFORMED_WORK_REGULAR_AREA_ATTACHMENTS_ID = "/v1/performedwork/regular/onarea/{work_id}/attachments/{id}/",
  // PERFORMED_WORK_REGULAR_AREA_ATTACHMENTS_ID_CONTENT = "/v1/performedwork/regular/onarea/{work_id}/attachments/{id}/content/",
  // PERFORMED_WORK_REGULAR_AREA_ATTACHMENTS_BATCH = "/v1/performedwork/regular/onarea/{work_id}/attachments/batch/",

  PERFORMED_WORK_REGULAR_ITEM_LIST = "/v1/performedwork/regular/onitem/",
  PERFORMED_WORK_REGULAR_ITEM_ID = "/v1/performedwork/regular/onitem/{id}/",
  PERFORMED_WORK_REGULAR_ITEM_BATCH = "/v1/performedwork/regular/onitem/batch/",
  PERFORMED_WORK_REGULAR_ITEM_ATTACHMENTS_LIST = "/v1/performedwork/regular/onitem/{work_id}/attachments/",
  PERFORMED_WORK_REGULAR_ITEM_ATTACHMENTS_ID = "/v1/performedwork/regular/onitem/{work_id}/attachments/{id}/",
  PERFORMED_WORK_REGULAR_ITEM_ATTACHMENTS_ID_CONTENT = "/v1/performedwork/regular/onitem/{work_id}/attachments/{id}/content/",
  PERFORMED_WORK_REGULAR_ITEM_ATTACHMENTS_BATCH = "/v1/performedwork/regular/onitem/{work_id}/attachments/batch/",

  PERFORMED_WORK_REGULAR_ITEM_COMMENTS = "/v1/performedwork/regular/onitem/comments/",
  PERFORMED_WORK_REGULAR_ITEM_COMMENTS_ID = "/v1/performedwork/regular/onitem/comments/{id}/",
  PERFORMED_WORK_REGULAR_ITEM_COMMENTS_BATCH = "/v1/performedwork/regular/onitem/comments/batch/",

  PERFORMED_WORK_REGULAR_ITEM_COMMENTS_ATTACHMENTS = "/v1/performedwork/regular/onitem/comments/{comment_id}/attachments/",
  PERFORMED_WORK_REGULAR_ITEM_COMMENTS_ATTACHMENTS_ID = "/v1/performedwork/regular/onitem/comments/{comment_id}/attachments/{id}/",
  PERFORMED_WORK_REGULAR_ITEM_COMMENTS_ATTACHMENTS_ID_CONTENT = "/v1/performedwork/regular/onitem/comments/{comment_id}/attachments/{id}/content/",
  PERFORMED_WORK_REGULAR_ITEM_COMMENTS_ATTACHMENTS_BATCH = "/v1/performedwork/regular/onitem/comments/{comment_id}/attachments/batch/",

  //endregion

  //region History

  HISTORY_ENTITY = "/v1/history/{entity_url_name}/{entity_id}/",
  HISTORY_USER = "/v1/history/users/{user_id}/",

  //endregion

  //region Work Domains

  WORK_DOMAINS = "/v1/workdomains/",
  WORK_DOMAINS_ID = "/v1/workdomains/{id}/",

  //endregion

  //region Work Order Priorities

  WORK_ORDER_PRIORITIES = "/v1/workorderpriorities/",
  WORK_ORDER_PRIORITIES_ID = "/v1/workorderpriorities/{id}/",

  //endregion

  //region Work Orders

  // WORK_ORDER_CORRECTIVE_ON_AREA = "/v1/workorders/corrective/onarea/",
  // WORK_ORDER_CORRECTIVE_ON_AREA_ID = "/v1/workorders/corrective/onarea/{id}/",
  // WORK_ORDER_CORRECTIVE_ON_AREA_BATCH = "/v1/workorders/corrective/onarea/batch/",

  // WORK_ORDER_CORRECTIVE_ON_AREA_ATTACHMENTS = "/v1/workorders/corrective/onarea/{wo_id}/attachments/",
  // WORK_ORDER_CORRECTIVE_ON_AREA_ATTACHMENTS_ID = "/v1/workorders/corrective/onarea/{wo_id}/attachments/{id}/",
  // WORK_ORDER_CORRECTIVE_ON_AREA_ATTACHMENTS_ID_CONTENT = "/v1/workorders/corrective/onarea/{wo_id}/attachments/{id}/content/",
  // WORK_ORDER_CORRECTIVE_ON_AREA_ATTACHMENTS_BATCH = "/v1/workorders/corrective/onarea/{wo_id}/attachments/batch/",

  // WORK_ORDER_CORRECTIVE_ON_AREA_COMMENTS = "/v1/workorders/corrective/onarea/comments/",
  // WORK_ORDER_CORRECTIVE_ON_AREA_COMMENTS_ID = "/v1/workorders/corrective/onarea/comments/{id}/",
  // WORK_ORDER_CORRECTIVE_ON_AREA_COMMENTS_BATCH = "/v1/workorders/corrective/onarea/comments/batch/",

  // WORK_ORDER_CORRECTIVE_ON_AREA_COMMENTS_ATTACHMENTS = "/v1/workorders/corrective/onarea/comments/{comment_id}/attachments/",
  // WORK_ORDER_CORRECTIVE_ON_AREA_COMMENTS_ATTACHMENTS_ID = "/v1/workorders/corrective/onarea/comments/{comment_id}/attachments/{id}/",
  // WORK_ORDER_CORRECTIVE_ON_AREA_COMMENTS_ATTACHMENTS_ID_CONTENT = "/v1/workorders/corrective/onarea/comments/{comment_id}/attachments/{id}/content/",
  // WORK_ORDER_CORRECTIVE_ON_AREA_COMMENTS_ATTACHMENTS_BATCH = "/v1/workorders/corrective/onarea/comments/{comment_id}/attachments/batch/",

  WORK_ORDER_CORRECTIVE_ON_ITEM = "/v1/workorders/corrective/onitem/",
  WORK_ORDER_CORRECTIVE_ON_ITEM_ID = "/v1/workorders/corrective/onitem/{id}/",
  WORK_ORDER_CORRECTIVE_ON_ITEM_BATCH = "/v1/workorders/corrective/onitem/batch/",

  WORK_ORDER_CORRECTIVE_ON_ITEM_ATTACHMENTS = "/v1/workorders/corrective/onitem/{wo_id}/attachments/",
  WORK_ORDER_CORRECTIVE_ON_ITEM_ATTACHMENTS_ID = "/v1/workorders/corrective/onitem/{wo_id}/attachments/{id}/",
  WORK_ORDER_CORRECTIVE_ON_ITEM_ATTACHMENTS_ID_CONTENT = "/v1/workorders/corrective/onitem/{wo_id}/attachments/{id}/content/",
  WORK_ORDER_CORRECTIVE_ON_ITEM_ATTACHMENTS_BATCH = "/v1/workorders/corrective/onitem/{wo_id}/attachments/batch/",

  WORK_ORDER_CORRECTIVE_ON_ITEM_COMMENTS = "/v1/workorders/corrective/onitem/comments/",
  WORK_ORDER_CORRECTIVE_ON_ITEM_COMMENTS_ID = "/v1/workorders/corrective/onitem/comments/{id}/",
  WORK_ORDER_CORRECTIVE_ON_ITEM_COMMENTS_BATCH = "/v1/workorders/corrective/onitem/comments/batch/",

  WORK_ORDER_CORRECTIVE_ON_ITEM_COMMENTS_ATTACHMENTS = "/v1/workorders/corrective/onitem/comments/{comment_id}/attachments/",
  WORK_ORDER_CORRECTIVE_ON_ITEM_COMMENTS_ATTACHMENTS_ID = "/v1/workorders/corrective/onitem/comments/{comment_id}/attachments/{id}/",
  WORK_ORDER_CORRECTIVE_ON_ITEM_COMMENTS_ATTACHMENTS_ID_CONTENT = "/v1/workorders/corrective/onitem/comments/{comment_id}/attachments/{id}/content/",
  WORK_ORDER_CORRECTIVE_ON_ITEM_COMMENTS_ATTACHMENTS_BATCH = "/v1/workorders/corrective/onitem/comments/{comment_id}/attachments/batch/",

  // WORK_ORDER_REGULAR_ON_AREA = "/v1/workorders/regular/onarea/",
  // WORK_ORDER_REGULAR_ON_AREA_ID = "/v1/workorders/regular/onarea/{id}/",
  // WORK_ORDER_REGULAR_ON_AREA_BATCH = "/v1/workorders/regular/onarea/batch/",

  // WORK_ORDER_REGULAR_ON_AREA_ATTACHMENTS = "/v1/workorders/regular/onarea/{wo_id}/attachments/",
  // WORK_ORDER_REGULAR_ON_AREA_ATTACHMENTS_ID = "/v1/workorders/regular/onarea/{wo_id}/attachments/{id}/",
  // WORK_ORDER_REGULAR_ON_AREA_ATTACHMENTS_ID_CONTENT = "/v1/workorders/regular/onarea/{wo_id}/attachments/{id}/content/",
  // WORK_ORDER_REGULAR_ON_AREA_ATTACHMENTS_BATCH = "/v1/workorders/regular/onarea/{wo_id}/attachments/batch/",

  // WORK_ORDER_REGULAR_ON_AREA_COMMENTS = "/v1/workorders/regular/onarea/comments/",
  // WORK_ORDER_REGULAR_ON_AREA_COMMENTS_ID = "/v1/workorders/regular/onarea/comments/{id}/",
  // WORK_ORDER_REGULAR_ON_AREA_COMMENTS_BATCH = "/v1/workorders/regular/onarea/comments/batch/",

  // WORK_ORDER_REGULAR_ON_AREA_COMMENTS_ATTACHMENTS = "/v1/workorders/regular/onarea/comments/{comment_id}/attachments/",
  // WORK_ORDER_REGULAR_ON_AREA_COMMENTS_ATTACHMENTS_ID = "/v1/workorders/regular/onarea/comments/{comment_id}/attachments/{id}/",
  // WORK_ORDER_REGULAR_ON_AREA_COMMENTS_ATTACHMENTS_ID_CONTENT = "/v1/workorders/regular/onarea/comments/{comment_id}/attachments/{id}/content/",
  // WORK_ORDER_REGULAR_ON_AREA_COMMENTS_ATTACHMENTS_BATCH = "/v1/workorders/regular/onarea/comments/{comment_id}/attachments/batch/",

  WORK_ORDER_REGULAR_ON_ITEM = "/v1/workorders/regular/onitem/",
  WORK_ORDER_REGULAR_ON_ITEM_ID = "/v1/workorders/regular/onitem/{id}/",
  WORK_ORDER_REGULAR_ON_ITEM_BATCH = "/v1/workorders/regular/onitem/batch/",

  WORK_ORDER_REGULAR_ON_ITEM_ATTACHMENTS = "/v1/workorders/regular/onitem/{wo_id}/attachments/",
  WORK_ORDER_REGULAR_ON_ITEM_ATTACHMENTS_ID = "/v1/workorders/regular/onitem/{wo_id}/attachments/{id}/",
  WORK_ORDER_REGULAR_ON_ITEM_ATTACHMENTS_ID_CONTENT = "/v1/workorders/regular/onitem/{wo_id}/attachments/{id}/content/",
  WORK_ORDER_REGULAR_ON_ITEM_ATTACHMENTS_BATCH = "/v1/workorders/regular/onitem/{wo_id}/attachments/batch/",

  WORK_ORDER_REGULAR_ON_ITEM_COMMENTS = "/v1/workorders/regular/onitem/comments/",
  WORK_ORDER_REGULAR_ON_ITEM_COMMENTS_ID = "/v1/workorders/regular/onitem/comments/{id}/",
  WORK_ORDER_REGULAR_ON_ITEM_COMMENTS_BATCH = "/v1/workorders/regular/onitem/comments/batch/",

  WORK_ORDER_REGULAR_ON_ITEM_COMMENTS_ATTACHMENTS = "/v1/workorders/regular/onitem/comments/{comment_id}/attachments/",
  WORK_ORDER_REGULAR_ON_ITEM_COMMENTS_ATTACHMENTS_ID = "/v1/workorders/regular/onitem/comments/{comment_id}/attachments/{id}/",
  WORK_ORDER_REGULAR_ON_ITEM_COMMENTS_ATTACHMENTS_ID_CONTENT = "/v1/workorders/regular/onitem/comments/{comment_id}/attachments/{id}/content/",
  WORK_ORDER_REGULAR_ON_ITEM_COMMENTS_ATTACHMENTS_BATCH = "/v1/workorders/regular/onitem/comments/{comment_id}/attachments/batch/",

  //endregion
}
